// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperNewsStory-cls1_PF6","cls2":"MultiPaperNewsStory-cls2_dSq MultiPaperNewsStory-cls1_PF6"};